

import { shouldAllowSearchIndexing } from '~/utils/seo-allowlist.js'

if (process.client)
  var WebFont = require('webfontloader');

export default {

  head() {

    const blockIndexing = this.$store.getters.getBlockSearchEngineIndexing
    const allowIndexing = shouldAllowSearchIndexing(this.$route.name, blockIndexing)

    return {
      title: this.$store.getters.getAccount.name + ' - Gift Cards',
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.$store.getters.getAccount.page_text ?? "My Toggle Shop"
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          property: 'og:site_name',
          content: this.$store.getters.getAccount.name
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.$store.getters.getAccount.name + ' - Gift Cards'
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content: 'https://' + this.$store.getters.getAccount.domain
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: this.$store.getters.getAccount.Image ? this.$store.getters.getAccount.Image.url : ''
        },
        {
          hid: 'og:type',
          name: 'og:type',
          content: 'website'
        },
        {
          hid: 'fb:app_id',
          name: 'fb:app_id',
          content: process.env.FACEBOOK_APP_ID
        },
        /*{
          hid: 'og:image:width',
          name: 'og:image:width',
          content: // this needs doing
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: // this needs doing
        },
        */
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.$store.getters.getAccount.Image ? this.$store.getters.getAccount.Image.url : ''
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.$store.getters.getAccount.page_text ?? "My Toggle Shop"
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.$store.getters.getAccount.name
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        ...(!allowIndexing
          ? [{
            hid: 'robots',
            name: 'robots',
            content: 'noindex, nofollow'
          }]
          : []),
      ],
      link: [
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: this.favicon ? this.favicon : '/toggle_favicon.svg'
        },
        {
          rel: 'apple-touch-icon',
          type: 'image/x-icon',
          href: this.webclip ? this.webclip : '/toggle_favicon.svg'
        },
        {
          rel: 'canonical',
          href: 'https://' + this.$store.getters.getAccount.domain
        }
      ],
      script: [
        {
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            'name': this.$store.getters.getAccount.name,
            'alternateName': this.$store.getters.getAccount.name + ' Shop',
            'url': 'https://' + this.$store.getters.getAccount.domain
          },
          type: 'application/ld+json'
        }
      ]
    }
  },

  watch: {
    accountFonts: function (val) {
      this.setFont();
    },
  },

  computed: {
    accountConfig() {
      return {
        styles: this.$store.getters.getCustomStyles || {
          cardHeader: {},
          descriptionText: {}
        }
      };
    },
    accountFonts() {
      return this.$store ? this.$store.getters.getAccountFonts : false;
    },
    favicon() {
      return this.$store.getters.getFavicon;
    },
    webclip() {
      return this.$store.getters.getWebclip;
    },
  },

  mounted() {
    this.setFont();
  },

  methods: {

    setFont() {
      if (!process.client || !this.accountFonts)
        return;

      this.$nextTick(() => {
        WebFont.load({
          google: {
            families: [this.accountFonts]
          }
        });
      });
    },
  },

}


